<!-- HELP -->
<div class="flex flex-row justify-start items-center">
  <button type="button">
    <mat-icon class="text-white icon" [svgIcon]="'arrow_left'"></mat-icon>
  </button>
</div>